import { fetchData } from "@client";

export async function getTeamContractorsQuery() {
  try {
    const res = await fetchData("/team/contractors");
    return res.results;
  } catch (e) {
    return [];
  }
}
